import Link from 'next/link'
import { NavGroup } from './NavGroup'
import { NavItem } from './NavItem'
import type { MenuItemType } from '../sidebar/SidebarUncontrolled'

/** One item from `useSidebarMenuItems` as a nav link, or as a group of them when it has children. */
export const MenuNavItem = ({ item }: { item: MenuItemType }) =>
  item.children == null ? (
    <NavItem
      icon={<item.Icon />}
      label={item.title}
      href={item.href}
      LinkComponent={Link}
      selected={item.selected}
      count={item.count}
      badge={item.badge}
    />
  ) : (
    <NavGroup icon={<item.Icon />} label={item.title} selected={item.selected}>
      {item.children.map((child) => (
        <MenuNavItem key={child.href} item={child} />
      ))}
    </NavGroup>
  )
